'use strict';

define("forum/login", ["validate_config", "ali_nc"], function (
    VC,
    NC
) {
    var isMobile = /(nokia|iphone|android|ipad|motorola|htc|huawei|novarra|CoolPad|blackberry|samsung|symbian|smartphone|wap|phone|windows ce|iemobile|opera\s*mobi|opera\*mini|320x320|240x320|176x220)/i.test(
        navigator.userAgent
    );
    var Login = {};
    var carousel = {};

    Login.init = function () {
        console.log("forum/login overrid init");
        carousel = initCarousel(["login", "forgetPwd", "setting"]);
        initCustomRegexValidate();
        initCountrySelect();
        initVerifyCodeLogin();
        initPasswordLogin();
        initForgetPassword();
        initForgetPasswordLink();
        initFirstSetting();
    };

    /**
     * 初始化国际区号选择框
     */
    function initCountrySelect() {
        var selectEl = $("select[name=areaCode]");
        var paneEl = selectEl.parent(".select-wrapper").find(".select-pane");

        // 当select变化时，将值更新到显示区域
        selectEl.on("change", function () {
            paneEl.html("+" + $(this).val());
        });
    }

    /**
     * 初始化表单自定义验证逻辑
     */
    function initCustomRegexValidate() {
        $.validator.addMethod(
            "regexp",
            function (value, element, param) {
                return this.optional(element) || value.match(param);
            },
            "输入格式有误"
        );
    }

    /**
     * 初始化验证码登录表单验证和提交逻辑。
     */
    function initVerifyCodeLogin() {
        VC.VERIFY_CODE_LOGIN_FORM_CONFIG.submitHandler = function (form) {
            var formEl = $(form);
            var errorEl = $("#login-error-notify");
            var submitEl = $("#phone-login-btn");

            if (submitEl.hasClass("disabled")) {
                return;
            }

            submitEl.addClass("disabled");

            formEl.ajaxSubmit({
                url: "/verifyCodeLogin",
                type: "POST",
                headers: {
                    "x-csrf-token": config.csrf_token,
                },
                success: function (data) {

                    if (data.firstCreate) {
                        $("#setting-form [name=uid]").val(data.uid);
                        carousel.toggleTo("setting");
                    } else {
                        var pathname = utils.urlToLocation(data.next).pathname;
                        var params = utils.params({
                            url: data.next,
                        });
                        params.loggedin = true;
                        var qs = decodeURIComponent($.param(params));

                        setTimeout(function () {
                            window.location.href = pathname + "?" + qs;
                        }, 300); 
                    }
                },
                error: function (data) {
                    if (
                        data.status === 403 &&
                        data.responseText === "Forbidden"
                    ) {
                        window.location.href =
                            config.relative_path + "/login?error=csrf-invalid";
                    } else {
                        errorEl.find("p").translateText(data.responseText);
                        errorEl.show();
                        submitEl.removeClass("disabled");

                        // Select the entire password if that field has focus
                        if ($("#password:focus").length) {
                            $("#password").select();
                        }
                    }
                },
            });
        };

        var formEl = $("#phone-login-form");
        formEl.validate(VC.VERIFY_CODE_LOGIN_FORM_CONFIG);

        var verifyCodeParams = {
            formEl: formEl,
            verifyCodeBtnEl: $("#login-verifycode-btn"),
            phoneNumberEl: formEl.find("[name=phone]"),
            areaCodeEl: formEl.find("[name=areaCode]"),
            type: 2,
            timeout: 60,
            aliNcScene: isMobile ? "login_h5" : "login",
            aliNcDivId: "#nc-login",
            aliNcAppkey: config.config.ALI_NC_APPKEY,
        };
        initVerifyCodeBtn(verifyCodeParams);
    }

    /**
     * 初始化密码登录表单验证和提交逻辑。
     */
    function initPasswordLogin() {
        VC.PASSWORD_LOGIN_FORM_CONFIG.submitHandler = function (form) {
            var errorEl = $("#login-error-notify");
            var formEl = $(form);
            var submitEl = $("#pwd-login-btn");

            if (submitEl.hasClass("disabled")) {
                return;
            }

            submitEl.addClass("disabled");
            formEl.ajaxSubmit({
                url: "/login",
                type: "POST",
                headers: {
                    "x-csrf-token": config.csrf_token,
                },
                success: function (data) {
                    var pathname = utils.urlToLocation(data.next).pathname;
                    var params = utils.params({
                        url: data.next,
                    });
                    params.loggedin = true;
                    var qs = decodeURIComponent($.param(params));

                    setTimeout(function () {
                        window.location.href = pathname + "?" + qs;
                    }, 300); 
                },
                error: function (data) {
                    if (
                        data.status === 403 &&
                        data.responseText === "Forbidden"
                    ) {
                        window.location.href =
                            config.relative_path + "/login?error=csrf-invalid";
                    } else {
                        errorEl.find("p").translateText(data.responseText);
                        errorEl.show();
                        submitEl.removeClass("disabled");

                        // Select the entire password if that field has focus
                        if ($("#password:focus").length) {
                            $("#password").select();
                        }
                    }
                },
            });
        };

        var formEl = $("#pwd-login-form");
        formEl.validate(VC.PASSWORD_LOGIN_FORM_CONFIG);
    }

    /**
     * 初始化忘记密码表单验证和提交逻辑。
     */
    function initForgetPassword() {
        VC.FORGET_PASSWORD_FORM_CONFIG.submitHandler = function (form) {
            var formEl = $(form);
            var submitEl = $("#forget-pwd-btn");

            if (submitEl.hasClass("disabled")) {
                return;
            }

            submitEl.addClass("disabled");

            formEl.ajaxSubmit({
                url: "/forgetPassword",
                type: "POST",
                headers: {
                    "x-csrf-token": config.csrf_token,
                },
                success: function (data) {
                    submitEl.removeClass("disabled");
                    carousel.toggleTo("login");
                    app.alertSuccess("更新成功");
                },
                error: function (errRes) {
                    submitEl.attr("disabled", false);
                    app.alertError(errRes.responseText || "网络错误");
                },
            });
        };

        var formEl = $("#forget-pwd-form");
        formEl.validate(VC.FORGET_PASSWORD_FORM_CONFIG);

        var verifyCodeParams = {
            formEl: formEl,
            verifyCodeBtnEl: $("#forget-verifycode-btn"),
            phoneNumberEl: formEl.find("[name=phone]"),
            areaCodeEl: formEl.find("[name=areaCode]"),
            type: 2,
            timeout: 60,
            aliNcScene: isMobile ? "login_h5" : "login",
            aliNcDivId: "#nc-forget-pwd",
            aliNcAppkey: config.config.ALI_NC_APPKEY,
        };
        initVerifyCodeBtn(verifyCodeParams);
    }

    /**
     * 初始化手机验证码首次登录后首次设置信息的表单
     */
    function initFirstSetting() {
        VC.FIRST_SETTING_FORM_CONFIG.submitHandler = function (form) {
            var formEl = $(form);
            var submitEl = $("#setting-btn");

            if (submitEl.hasClass("disabled")) {
                return;
            }

            submitEl.addClass("disabled");

            socket.emit(
                "user.changeNicknamePassword",
                {
                    uid: formEl.find("[name=uid]").val(),
                    nickname: formEl.find("[name=nickname]").val(),
                    password: formEl.find("[name=password]").val(),
                    confirmPassword: formEl.find("[name=confirmPwd]").val(),
                },
                function (err) {
                    submitEl.removeClass("disabled");

                    if (err) {
                        return app.alertError(err.message || "设置失败");
                    }

                    app.alertSuccess("设置成功");

                    window.location.href = "/";
                }
            );
        };

        var formEl = $("#setting-form");
        formEl.validate(VC.FIRST_SETTING_FORM_CONFIG);
    }

    /**
     * 初始化忘记密码链接，实现切换到忘记密码Form和返回逻辑。
     */
    function initForgetPasswordLink() {
        $(".toggle-forget-pwd").on("click", function () {
            carousel.toggleTo("forgetPwd", function () {
                $("#forget-pwd-form").clearForm().resetForm();
            });
        });

        $(".form-icon.arrow.back").on("click", function () {
            carousel.toggleTo("login", function () {
                $("#login-nav li:first-child a").click();
                $("#pwd-login-form").clearForm();
                $("#phone-login-form").clearForm();
                $("#pwd-login-form").validate().resetForm();
                $("#phone-login-form").validate().resetForm();
            });
        });

        $(".setting-part .skip").on("click", function () {
            window.location.href = "/";
        });

        $("#login-nav li a").click(function () {
            var target = $(this).attr("data-target");
            $(target + "-form")
                .validate()
                .resetForm();
        });
    }

    /**
     * 初始化获取验证码按钮。
     * @param {*} verifyCodeParams
     */
    function initVerifyCodeBtn(verifyCodeParams) {
        var formEl = verifyCodeParams.formEl;
        var btnEl = verifyCodeParams.verifyCodeBtnEl;
        var phoneEl = verifyCodeParams.phoneNumberEl;
        var areaCodeEl = verifyCodeParams.areaCodeEl;
        var timeout = verifyCodeParams.timeout || 60;
        var type = verifyCodeParams.type;

        var timeCountDown = 0;
        var timeCountDownInterval = null;

        //阿里滑动验证相关数据
        var needSlideCheck = false;
        var aliNcSig;
        var aliNcSessionId;
        var aliNcAliyunToken;
        var aliNc;
        var aliNcAppkey = verifyCodeParams.aliNcAppkey;
        var aliNcDivId = verifyCodeParams.aliNcDivId;
        var aliNcScene = verifyCodeParams.aliNcScene;

        btnEl.on("click", function (e) {
            var targetEl = $(e.target);
            if (!formEl.validate().element(phoneEl)) {
                return false;
            }

            if (timeCountDown > 0 && timeCountDown <= timeout) {
                return false;
            }

            //如果前一次获取验证码返回的是要求滑动验证,则提示要求滑动验证。
            if (needSlideCheck && !aliNcSig) {
                app.alertError("请先滑动验证");
                return false;
            }

            var reqData = {
                phone: phoneEl.val(),
                pf: 3,
                version: "web",
                type: type,
                areaCode: areaCodeEl.val(),
                evkAppId: config.config.APPID,
                sessionId: aliNcSessionId,
                sig: aliNcSig,
                aliyunToken: aliNcAliyunToken,
                scene: aliNcScene,
            };

            timeCountDown = timeout;

            $.get(
                config.config.BASE_API +
                    "/v1/common/user/sendPhoneVerificationCodeByType",
                reqData
            )
                .then(function (res) {
                    // 判断是否需要开始滑动验证。
                    if (res.status === 0 && +res.errInfo.code == 10012) {
                        needSlideCheck = true;
                        if (!aliNc) {
                            initNc(
                                aliNcDivId,
                                aliNcAppkey,
                                aliNcScene,
                                function success(data) {
                                    aliNcSessionId = data.sessionId;
                                    aliNcSig = data.sig;
                                    aliNcAliyunToken = data.token;
                                    aliNcScene = data.scene;
                                },
                                function getNc(exportNc) {
                                    aliNc = exportNc;
                                }
                            );
                        } else {
                            aliNc.reset();
                            aliNcSessionId = sig = aliNcAliyunToken = undefined;
                        }
                    }

                    if (needSlideCheck) {
                        // 如果处于滑动验证阶段，发送请求失败，则清空滑动验证数据。
                        if (res.status === 0) {
                            aliNc && aliNc.reset();
                            aliNcSessionId = sig = aliNcAliyunToken = undefined;
                        } else {
                            // 如果发送请求成功，则倒计时60后清空滑动验证数据。
                            setTimeout(function () {
                                aliNc && aliNc.reset();
                                aliNcSessionId = sig = aliNcAliyunToken = undefined;
                            }, 60000);
                        }
                    }

                    if (res.status === 1) {
                        targetEl.attr("disabled", true);
                        targetEl.html(timeCountDown + "s后重试");
                        timeCountDownInterval = setInterval(function () {
                            timeCountDown--;
                            if (timeCountDown == 0) {
                                clearInterval(timeCountDownInterval);
                                targetEl.attr("disabled", false);
                                targetEl.html("获取验证码");
                            } else {
                                targetEl.html(timeCountDown + "s后重试");
                            }
                        }, 1000);
                    } else {
                        if (+res.errInfo.code !== 10012) {
                            var msg = "";
                            switch (+res.errInfo.code) {
                                case 10002:
                                    msg = "短信发送失败，请稍后重试";
                                    break;
                                case 10013:
                                    msg = "滑块验证失败，请稍后重试";
                                    break;
                            }
                            app.alertError(
                                msg || res.errInfo.message || res.errInfo
                            );
                        }
                        setTimeout(function () {
                            timeCountDown = 0;
                        }, 3000);
                        return false;
                    }
                })
                .fail(function (err) {
                    if (err.status === 503) {
                        app.alert({
                            type: "warning",
                            message: "获取验证码过于频繁，请稍后再试",
                        });
                    } else {
                        app.alertError("网络错误");
                    }
                });
        });
    }

    /**
     * 初始化界面切换容器
     *
     * @param {*} list
     */
    function initCarousel(list) {
        var $carousel = $("#carousel-container");
        $carousel.carousel({
            interval: false,
            pause: null,
        });
        list = list || [];
        return {
            toggleTo: function (item, before, after) {
                var index = list.indexOf(item);
                if (index !== -1) {
                    before && before(); // eslint-disable-line
                    $carousel.carousel(index);
                    after && after(); // eslint-disable-line
                } else {
                    console.error(
                        "There is no item(" +
                            item +
                            ") in list(" +
                            list.toString() +
                            ")!"
                    );
                }
            },
        };
    }

    // 初始化滑动验证码
    function initNc(id, appkey, scene, success, getNc) {
        var nc_token = [appkey, new Date().getTime(), Math.random()].join(":");
        NC.init(
            {
                renderTo: id,
                appkey: appkey,
                scene: scene,
                token: nc_token,
                customWidth: "100%",
                bannerHidden: false,
                callback: function (data) {
                    if (success) {
                        success({
                            appkey: appkey,
                            token: nc_token,
                            scene: scene,
                            sessionId: data.csessionid,
                            sig: data.sig,
                        });
                    }
                },
            },
            function (nc) {
                nc.upLang("cn", {
                    _startTEXT: "请按住滑块，拖动到最右边",
                    _yesTEXT: "验证通过",
                    _error300:
                        '哎呀，出错了，单击<a href="javascript:__nc.reset()">刷新</a>再来一次',
                    _errorNetwork:
                        '网络不给力，请<a href="javascript:__nc.reset()">单击刷新</a>',

                    LOADING: "加载中...", // 加载
                    SLIDER_LABEL: "请向右滑动验证", // 等待滑动
                    CHECK_Y: "验证通过", // 通过
                    ERROR_TITLE: "非常抱歉，这出错了...", // 拦截
                    CHECK_N: "验证未通过", // 准备唤醒二次验证
                    OVERLAY_INFORM:
                        "经检测你当前操作环境存在风险，请输入验证码", // 二次验证
                    TIPS_TITLE: "验证码错误，请重新输入", // 验证码输错时的提示
                });
                // eslint-disable-next-line no-unused-expressions
                getNc && getNc(nc);
            }
        );
    }

    return Login;
});
